import { Image } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { ColumnComponentProps } from '../../../types/activity-column-types';
import {
  ActivityImageObject,
  getImageUrl,
} from '../../../utils/activity-formatters';

export function ImageColumn({
  info,
}: ColumnComponentProps<
  BackofficeActivitiesOrderItem,
  ActivityImageObject | string[] | undefined
>) {
  const imageUrl = getImageUrl(info.row.original);

  return (
    <Image
      src={imageUrl}
      alt=""
      objectFit="cover"
      borderRadius="md"
      border="1px"
      borderColor="gray.33"
      w="10"
      h="10"
      loading="lazy"
    />
  );
}
